// extracted by mini-css-extract-plugin
export default {"products":"ProductList_products__VJ-mt"};